import { getGlobal } from './global'

export const StorageKey = {
  HAS_CLOSED_COOKIE_POPUP: 'HAS_CLOSED_COOKIE_POPUP',
  INTERSTITIAL_VIEWED: 'INTERSTITIAL_VIEWED',
  INTERSTITIAL_VIEWED_TIME: 'INTERSTITIAL_VIEWED_TIME',
  HCPD_LOCATION_FILTER_INPUT: 'HCPD_LOCATION_FILTER_INPUT',
  HCPD_RADIUS_FILTER_INPUT: 'HCPD_RADIUS_FILTER_INPUT',
  HCPD_ADDITIONAL_FILTER_INPUT: 'HCPD_ADDITIONAL_FILTER_INPUT',
  HCPD_LAT_LON: 'HCPD_LAT_LON',
  ADVANCE_ARTICLE_FILTER: 'ADVANCE_ARTICLE_FILTER',
  MEDIA_LIBRARY_MEDIA_FILTER: 'MEDIA_LIBRARY_MEDIA_FILTER',
  MEDIA_LIBRARY_TOPIC_FILTER: 'MEDIA_LIBRARY_TOPIC_FILTER',
  CME_MEDIA_LIBRARY_CREDITS_FILTER: 'CME_MEDIA_LIBRARY_CREDITS_FILTER',
  CME_MEDIA_LIBRARY_MEDIA_FILTER: 'CME_MEDIA_LIBRARY_MEDIA_FILTER',
  CME_MEDIA_LIBRARY_TOPIC_FILTER: 'CME_MEDIA_LIBRARY_TOPIC_FILTER',
  HCPD_ADMIN_APPROVAL_FILTER: 'HCPD_ADMIN_APPROVAL_FILTER',
  HCPD_ADMIN_GQL_TOKEN: 'HCPD_ADMIN_GQL_TOKEN',
  PRODUCT_CATEGORY_FILTER: 'PRODUCT_CATEGORY_FILTER',
  PRODUCT_BRAND_FILTER: 'PRODUCT_BRAND_FILTER',
  PRODUCT_TYPE_FILTER: 'PRODUCT_TYPE_FILTER',
}

export const StorageType = {
  LOCAL: 'localStorage',
  SESSION: 'sessionStorage',
}

const global = getGlobal()

export const getStorageString = ({ key, storageType = StorageType.LOCAL }) =>
  global?.[storageType]?.getItem(key) || undefined

export const setStorageString = ({
  key,
  value,
  storageType = StorageType.LOCAL,
}) => global?.[storageType].setItem(key, value)

export const removeStorageString = ({ key, storageType = StorageType.LOCAL }) =>
  global?.[storageType]?.removeItem(key)
